import { FINANCE_PAYMENT_DETAILS_ROUTE, FINANCE_PAYMENT_DETAILS_ROUTE_MORE_FUNDS_REQUESTED, VEHICLE_COLLECTION_ROUTE } from 'Utilities/routing';

import { DOCUMENT_CAPTURE_ROUTE_NAMES, PAYMENT_STATUS_ROUTE_NAMES } from '../../documentCapture/DocumentCapture.helpers';
import { PROFILING_PATH } from '../../vehicleProfiling/VehicleProfiling.constants';

export const profileRouteChecker = ({
  profileSubPathname,
  url,
}: {
  profileSubPathname: string;
  url: string;
}): boolean => {
  const vrm = url.split('/').filter((segment) => segment !== '')[0];
  const isProfileSubRoute = url.startsWith(`/${vrm}${PROFILING_PATH.PROFILE}${profileSubPathname}`);
  return isProfileSubRoute;
};

export type IsAllowedPageRouteForHooksParams = {
  hookName: string;
  slug?: string;
}

type HooksToRouteMap = {
  [key: string]: boolean;
};

const ALLOWED_SLUGS = new Set([
  VEHICLE_COLLECTION_ROUTE,
  DOCUMENT_CAPTURE_ROUTE_NAMES.DEALER_DETAILS,
  DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_DOCUMENTS,
  FINANCE_PAYMENT_DETAILS_ROUTE,
  FINANCE_PAYMENT_DETAILS_ROUTE_MORE_FUNDS_REQUESTED,
  PAYMENT_STATUS_ROUTE_NAMES.FINANCE_FUNDS_RECEIVED,
  PAYMENT_STATUS_ROUTE_NAMES.SALE_COMPLETE,
  PAYMENT_STATUS_ROUTE_NAMES.VEHICLE_PAYMENT,
].map((v) => v.replace('/', '')));

export const isAllowedPageRouteForHooks = ({ hookName, slug }: IsAllowedPageRouteForHooksParams): boolean => {
  if (!slug) {
    return false;
  }

  const canFetch = ALLOWED_SLUGS.has(slug);

  const hooksToRouteMap: HooksToRouteMap = {
    useGetBeneficiary: canFetch,
    useGetCollectionDetails: canFetch,
  };

  return hooksToRouteMap[hookName] ?? false;
};

export const FORBIDDEN_STATUS_CODES_FOR_VEHICLE_COLLECTION_PAGE = 404;
